import { PendingWorkOrderData, ApprovalStatus, UserRole } from "../types";

// Mock data for pending work orders in approval workflow
export const mockPendingWorkOrdersData: PendingWorkOrderData[] = [
  {
    id: "wo-pending-001",
    workOrderNumber: "WO/2025-26/HYD/0042",
    workOrderTitle: "Core & Shell - Tower B",
    workOrderDescription:
      "Complete structural work for Tower B including foundation and RCC work",
    siteId: "site-001",
    siteName: "HYD Site A",
    projectId: "proj-001",
    projectName: "Tower B",
    contractType: "Construction Work",
    contractWith: "General Contractor",
    contractorId: "cont-001",
    contractorName: "Galaxy Infra",
    workOrderOwner: "John Smith",
    plannedStartDate: "2025-08-10",
    plannedEndDate: "2026-02-15",
    totalValue: 1897280,
    taxAmount: 340000,
    grossValue: 2237280,
    status: ApprovalStatus.Pending,
    createdAt: "2025-08-01",
    createdBy: "John Smith",
    lastActionBy: "John Smith",
    lastActionDate: "2025-08-01",
    lastActionRole: UserRole.Creator,
    remarks: "Initial submission for approval",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "John Smith",
        actionDate: "2025-08-01",
        role: UserRole.Creator,
        comments: "Work order created and submitted for approval",
      },
    ],
  },
  {
    id: "wo-pending-002",
    workOrderNumber: "WO/2025-26/HYD/0043",
    workOrderTitle: "Podium Finishes",
    workOrderDescription: "Interior and exterior finishing work for podium",
    siteId: "site-001",
    siteName: "HYD Site A",
    projectId: "proj-002",
    projectName: "Tower A",
    contractType: "Construction Work",
    contractWith: "Sub Contractor",
    contractorId: "cont-002",
    contractorName: "Alpha Constructions",
    workOrderOwner: "Jane Doe",
    plannedStartDate: "2025-08-01",
    plannedEndDate: "2025-12-31",
    totalValue: 950000,
    taxAmount: 171000,
    grossValue: 1121000,
    status: ApprovalStatus.Pending,
    createdAt: "2025-07-25",
    createdBy: "Jane Doe",
    lastActionBy: "Anil Rao",
    lastActionDate: "2025-08-05",
    lastActionRole: UserRole.Checker,
    remarks: "Rates verified, scope ok",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "Jane Doe",
        actionDate: "2025-07-25",
        role: UserRole.Creator,
        comments: "Work order created and submitted for approval",
      },
      {
        action: "Checked",
        actionBy: "Anil Rao",
        actionDate: "2025-08-05",
        role: UserRole.Checker,
        comments:
          "Contract value verified against budget. Contractor selection appropriate. All documents present.",
      },
    ],
  },
  {
    id: "wo-pending-003",
    workOrderNumber: "WO/2025-26/BLR/0018",
    workOrderTitle: "MEP Package",
    workOrderDescription: "Mechanical, Electrical & Plumbing work",
    siteId: "site-002",
    siteName: "BLR Site C",
    projectId: "proj-003",
    projectName: "Tower C",
    contractType: "Construction Work",
    contractWith: "General Contractor",
    contractorId: "cont-003",
    contractorName: "Zenith MEP",
    workOrderOwner: "Mike Johnson",
    plannedStartDate: "2025-09-01",
    plannedEndDate: "2026-05-31",
    totalValue: 2923729,
    taxAmount: 526271,
    grossValue: 3450000,
    status: ApprovalStatus.Pending,
    createdAt: "2025-07-15",
    createdBy: "Mike Johnson",
    lastActionBy: "Priya Sharma",
    lastActionDate: "2025-08-08",
    lastActionRole: UserRole.Verifier,
    remarks: "Technical specifications verified, awaiting final approval",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "Mike Johnson",
        actionDate: "2025-07-15",
        role: UserRole.Creator,
        comments: "MEP work order created with detailed specifications",
      },
      {
        action: "Checked",
        actionBy: "Anil Rao",
        actionDate: "2025-08-02",
        role: UserRole.Checker,
        comments: "Budget allocation verified. Contractor credentials checked.",
      },
      {
        action: "Verified",
        actionBy: "Priya Sharma",
        actionDate: "2025-08-08",
        role: UserRole.Verifier,
        comments:
          "Rate calculations verified. Tax computations correct. Payment terms aligned with policy.",
      },
    ],
  },
  {
    id: "wo-pending-004",
    workOrderNumber: "WO/2025-26/CHN/0025",
    workOrderTitle: "Foundation Work Package",
    workOrderDescription:
      "Complete foundation work including excavation and concrete pouring",
    siteId: "site-003",
    siteName: "Chennai Site D",
    projectId: "proj-004",
    projectName: "Residential Complex",
    contractType: "Construction Work",
    contractWith: "General Contractor",
    contractorId: "cont-004",
    contractorName: "L&T Civil Infra",
    workOrderOwner: "Sarah Wilson",
    plannedStartDate: "2025-06-20",
    plannedEndDate: "2025-11-30",
    totalValue: 1800000,
    taxAmount: 324000,
    grossValue: 2124000,
    status: ApprovalStatus.Pending,
    createdAt: "2025-08-10",
    createdBy: "Sarah Wilson",
    lastActionBy: "Sarah Wilson",
    lastActionDate: "2025-08-10",
    lastActionRole: UserRole.Creator,
    remarks: "Urgent foundation work required",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "Sarah Wilson",
        actionDate: "2025-08-10",
        role: UserRole.Creator,
        comments: "Foundation work order created for immediate execution",
      },
    ],
  },
  {
    id: "wo-pending-005",
    workOrderNumber: "WO/2025-26/PUN/0012",
    workOrderTitle: "Landscaping & External Works",
    workOrderDescription: "Garden development and external area finishing",
    siteId: "site-004",
    siteName: "Pune Site E",
    projectId: "proj-005",
    projectName: "Commercial Plaza",
    contractType: "Service",
    contractWith: "Sub Contractor",
    contractorId: "cont-005",
    contractorName: "Green Landscaping",
    workOrderOwner: "David Brown",
    plannedStartDate: "2025-08-15",
    plannedEndDate: "2025-10-15",
    totalValue: 680000,
    taxAmount: 122400,
    grossValue: 802400,
    status: ApprovalStatus.Pending,
    createdAt: "2025-08-03",
    createdBy: "David Brown",
    lastActionBy: "Anil Rao",
    lastActionDate: "2025-08-12",
    lastActionRole: UserRole.Checker,
    remarks: "Scope and pricing verified",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "David Brown",
        actionDate: "2025-08-03",
        role: UserRole.Creator,
        comments: "Landscaping work order for final phase",
      },
      {
        action: "Checked",
        actionBy: "Anil Rao",
        actionDate: "2025-08-12",
        role: UserRole.Checker,
        comments:
          "Service contract terms verified. Environmental clearances in place.",
      },
    ],
  },
  {
    id: "wo-pending-006",
    workOrderNumber: "WO/2025-26/HYD/0044",
    workOrderTitle: "Electrical Infrastructure",
    workOrderDescription: "Main electrical panel installation and wiring",
    siteId: "site-001",
    siteName: "HYD Site A",
    projectId: "proj-001",
    projectName: "Tower B",
    contractType: "Construction Work",
    contractWith: "Sub Contractor",
    contractorId: "cont-006",
    contractorName: "PowerTech Solutions",
    workOrderOwner: "Raj Patel",
    plannedStartDate: "2025-09-01",
    plannedEndDate: "2025-12-15",
    totalValue: 1250000,
    taxAmount: 225000,
    grossValue: 1475000,
    status: ApprovalStatus.Pending,
    createdAt: "2025-07-20",
    createdBy: "Raj Patel",
    lastActionBy: "Priya Sharma",
    lastActionDate: "2025-08-15",
    lastActionRole: UserRole.Verifier,
    remarks: "Technical compliance verified, ready for final approval",
    approvalHistory: [
      {
        action: "Created",
        actionBy: "Raj Patel",
        actionDate: "2025-07-20",
        role: UserRole.Creator,
        comments:
          "Electrical infrastructure work order with safety requirements",
      },
      {
        action: "Checked",
        actionBy: "Anil Rao",
        actionDate: "2025-08-08",
        role: UserRole.Checker,
        comments: "Budget and contractor qualifications verified",
      },
      {
        action: "Verified",
        actionBy: "Priya Sharma",
        actionDate: "2025-08-15",
        role: UserRole.Verifier,
        comments:
          "Electrical specifications meet safety standards. Payment terms appropriate.",
      },
    ],
  },
];

// Mock site options for filters
export const mockSiteOptions = [
  { label: "HYD Site A", value: "site-001" },
  { label: "BLR Site C", value: "site-002" },
  { label: "Chennai Site D", value: "site-003" },
  { label: "Pune Site E", value: "site-004" },
];

// Mock project options for filters
export const mockProjectOptions = [
  { label: "Tower B", value: "proj-001" },
  { label: "Tower A", value: "proj-002" },
  { label: "Tower C", value: "proj-003" },
  { label: "Residential Complex", value: "proj-004" },
  { label: "Commercial Plaza", value: "proj-005" },
];

// Mock contract type options
export const mockContractTypeOptions = [
  { label: "Construction", value: "Construction" },
  { label: "Service", value: "Service" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Others", value: "Others" },
];

// Function to get pending work orders by role
export const getPendingWorkOrdersByRole = (
  role: UserRole
): PendingWorkOrderData[] => {
  return mockPendingWorkOrdersData.filter((wo) => {
    switch (role) {
      case UserRole.Checker:
        return wo.status === ApprovalStatus.SubmittedForApproval;
      case UserRole.Verifier:
        return wo.status === ApprovalStatus.Checked;
      case UserRole.Approver:
        return wo.status === ApprovalStatus.Verified;
      default:
        return false;
    }
  });
};

// Function to get work order approval history
export const getWorkOrderApprovalHistory = (id: string) => {
  const workOrder = mockPendingWorkOrdersData.find((wo) => wo.id === id);
  return workOrder?.approvalHistory || [];
};
